// document.addEventListener("DOMContentLoaded", () => {
//   const inlineMenu = document.querySelector(".header__inline-menu");
//   const detailsItems = inlineMenu.querySelectorAll("details");
//   const listItems = inlineMenu.querySelectorAll("li");

//   listItems.forEach((item) => {
//     if (item.querySelector("#HeaderMenu-shop") == null) {
//       item.addEventListener("mouseover", () => {
//         document.getElementById("megamenu").classList.add("hidden");
//         document.querySelector(".megamenu-left").classList.remove("show");
//       });
//     }
//   });

//   detailsItems.forEach((item) => {
//     if (item.querySelector("#HeaderMenu-shop")) {
//       item.addEventListener("mouseover", () => {
//         item.querySelector(".header__submenu").style.display = "none";
//         document.getElementById("megamenu").classList.remove("hidden");
//         document.querySelector(".megamenu-left").classList.add("show");

//         var parentDiv =
//           document.getElementById("megamenu").parentElement.parentElement;
//         parentDiv.classList.add("sticky-megamenu");
//       });

//       item.addEventListener("click", (e) => {
//         e.preventDefault();
//         window.location.href = "/collections/all";
//       });

//       document
//         .getElementById("megamenu")
//         .addEventListener("mouseleave", function (e) {
//           document.getElementById("megamenu").classList.add("hidden");

//           var parentDiv =
//             document.getElementById("megamenu").parentElement.parentElement;
//           parentDiv.classList.remove("sticky-megamenu");
//         });
//     }

//     const ulElement = item.querySelector("ul");
//     item.addEventListener("mouseover", () => {
//       item.setAttribute("open", true);

//       ulElement.addEventListener("mouseleave", () => {
//         item.removeAttribute("open");
//       });

//       item.addEventListener("mouseleave", () => {
//         item.removeAttribute("open");
//       });
//     });
//   });

//   var allText = document.querySelectorAll(".dealer--address");
//   document
//     .querySelector(".dealer select")
//     .addEventListener("change", (event) => {
//       allText.forEach((text) => {
//         text.removeAttribute("style");
//       });
//       var country = event.target.value;
//       document.getElementById(country).style.display = "block";
//     });
// });

// const header = document.querySelector("sticky-header"); // Replace with your header selector
// const megamenu = document.querySelector("#megamenu"); // Replace with your megamenu selector

// let lastScrollY = window.scrollY; // Keep track of the last scroll position

// window.addEventListener("scroll", () => {
//   const currentScrollY = window.scrollY;

//   // Check if scrolling down
//   if (currentScrollY > lastScrollY) {
//     // Scrolling down, hide the megamenu
//     megamenu.classList.add("hidden");
//   }

//   // Update the last scroll position
//   lastScrollY = currentScrollY;
// });

document.addEventListener("DOMContentLoaded", function () {
  GLightbox({
    selector: ".glightbox",
  });
});
